<div class="c__title">
  @if (data?.icon) {
    <sd-icon [name]="data.icon" data-testid="test-icon" />
  }
  <p class="is-body-m is-bold" data-testid="test-title">{{ data.title }}</p>
</div>
@if (data?.description) {
  <div class="c__description">
    <p class="is-body-m" data-testid="test-description">{{ data.description }}</p>
  </div>
}
<sd-price
  [price]="data.price"
  [discountedPrice]="data?.discountedPrice"
  [recommendedPrice]="data?.recommendedPrice"
  [isDiscountWithRecommendedPrice]="data?.isDiscountWithRecommendedPrice"
  [isSSR]="hidePrice"
  [isSmall]="true"
/>
<sd-link [isButton]="true" [isSecondary]="true" [link]="data.link" data-testid="test-link">
  {{ data.link?.linkName }}
</sd-link>
